import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/Navbar/Navbar'
import Logo from '../../images/NewWFCOLogo2.svg'
import GridLayout from '../../components/grid-layout/grid-layout';

import { homepgNavbarData } from '../../data/data';
import { homepgFooterData } from '../../data/data';
import { companyDirectoryData } from '../../data/data';

const Directory = () => {
  return (
    <Fragment>
        <Navbar hclass={'wpo-site-header-s1'} topbarNone={'topbar-none'} Logo={Logo} data={homepgNavbarData}/>
        <PageTitle pageTitle={'4DWW Company Directory'} pagesub={'Directory'}/> 
        {/* <StudiesList data={studiesList}/> */}
        <GridLayout data={companyDirectoryData}/>
        <Footer logo={Logo} data={homepgFooterData}/>
    </Fragment>
  );
};

export default Directory;
